import { render, staticRenderFns } from "./advRelation.vue?vue&type=template&id=79e65390&scoped=true&"
import script from "./advRelation.vue?vue&type=script&lang=js&"
export * from "./advRelation.vue?vue&type=script&lang=js&"
import style0 from "./advRelation.vue?vue&type=style&index=0&id=79e65390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e65390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e65390')) {
      api.createRecord('79e65390', component.options)
    } else {
      api.reload('79e65390', component.options)
    }
    module.hot.accept("./advRelation.vue?vue&type=template&id=79e65390&scoped=true&", function () {
      api.rerender('79e65390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/advRelation.vue"
export default component.exports